import { createAction } from "redux-starter-kit";
import {
  NOTI_COMP_START_LOAD,
  NOTI_COMP_END_LOAD,
  NOTI_COMP_LOAD_FAIL,
  NOTI_COMP_DELETE
} from "../actionTypes";
import {
  getNotificationsApi,
  delNotificationApi
} from "../../api/notification";

export const startLoadNotiAction = createAction(NOTI_COMP_START_LOAD);
export const endLoadNotiAction = createAction(NOTI_COMP_END_LOAD);
export const notiFailLoadAction = createAction(NOTI_COMP_LOAD_FAIL);
export const notiDelAction = createAction(NOTI_COMP_DELETE);

export function loadNotiRequestAction() {
  return async dispatch => {
    dispatch(startLoadNotiAction());

    try {
      let notifications = await getNotificationsApi();
      dispatch(endLoadNotiAction({ notifications }));
    } catch (e) {
      dispatch(notiFailLoadAction({ errMsg: e.toString() }));
    }
  };
}

export function delNotiRequestAction(notificationID, toast) {
  return async dispatch => {
    dispatch(notiDelAction({ notificationID }));

    try {
      await delNotificationApi(notificationID);
    } catch (e) {
      toast.error(e.toString(), {
        onClose: () => dispatch(loadNotiRequestAction())
      });
    }
  };
}
